import { VerticalTabNavTitle } from '../../../components'
import { MemberMessage } from '../../../utils/classes/graphql'

interface MemberMessageTabNavTitleProps {
  item: MemberMessage
}

export const MemberMessageTabNavTitle = ({
  item
}: MemberMessageTabNavTitleProps) => {
  const { lahetysPvm, viestinNimi } = item

  return <VerticalTabNavTitle date={lahetysPvm} title={viestinNimi} />
}
